import { ReactComponent as FriendsIcon } from "assets/img/friends/welcome.svg";
import { Button } from "components/elements";

type NoFriendsProps = {
    setModalOpen: (isOpen: boolean) => void;
};

export const NoFriends = ({ setModalOpen }: NoFriendsProps) => {
    return (
        <div className="flex h-4/6 flex-col items-center justify-center rounded border bg-[white] p-8 text-center shadow-md">
            <div className="mb-4">
                <div className="">
                    <FriendsIcon className="h-20 w-20" />
                </div>
            </div>
            <h2 className="mb-2 text-lg font-semibold">Welcome to your friends list</h2>
            <p className="mb-4 text-sm text-gray-500">
                You don't have any friends yet. Start adding to your list!
            </p>
            {/*<Button onClick={() => setModalOpen(true)} variant="primary">
                Find New Friend
            </Button>*/}
        </div>
    );
};
